module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("Nazar's Journey")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "font-family": "Calisto Mt",
      "margin-left": "-10px",
      "margin-top": "20px",
      "font-weight": "normal !important"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_000#toc_id_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_001#toc_id_2"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_002#toc_id_3"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_003#toc_id_4"
    }
  }, [_vm._v("Acknowledgement")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_004#toc_id_5"
    }
  }, [_vm._v("Endorsements")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_006#toc_id_6"
    }
  }, [_vm._v("Nazar’s JourneyIntroductionBy Joseph Pearce")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_008#toc_id_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Artwork")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_010#toc_id_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Skylark")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_011#toc_id_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nightmare of Cruel Memories")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_012#toc_id_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mar Addai")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_013#toc_id_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Amira and Yousif")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_014#toc_id_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("By Paths They Have NotKnown I Will Guide Them")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_015#toc_id_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evening at Baba’s Farmhouse")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_017#toc_id_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Good Samaritan")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_018#toc_id_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Checkpoint in the Wilderness")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_019#toc_id_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("He Carried You UntilYou Reached This Place")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0